import { Box } from '@fedsim/components';
import StoreVersion from "components/store-version"

function Main({ children = null }) {
  return (
    <Box
      component='main'
      sx={{
        px: {
          xs: 1,
          sm: 2,
          md: 2,
        },
      }}
    >
      <>
        <StoreVersion />
        {children}
      </>
    </Box>
  )
}

export default Main
